import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/org"

export function findByUserRole() {
  return request({
    url: prefix + '/findByUserRole',
    method: 'get'
  })
}

export function getUserOrgInfo() {
  return request({
    url: prefix + '/getUserOrgInfo',
    method: 'get'
  })
}

export function getOrgInfo(orgId) {
  return request({
    url: prefix + '/getOrgInfo/'+orgId,
    method: 'get'
  })
}


export function pageList(criteria) {
  return request({
    url: prefix + '/pagelist',
    method: 'post',
    data: criteria,
  })
}
